/* Spill Safe Storage — header drawer + compact nav, bund size calculator, guide dialogs, workplace carousel (28-9-2026, refined 29-9-2026). */
(function () {
  'use strict';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- header drawer ---------- */
  var drawer = document.querySelector('[data-ssh-drawer]');
  var opener = document.querySelector('[data-ssh-open]');
  function openDrawer() {
    if (!drawer) return;
    drawer.hidden = false;
    document.documentElement.classList.add('ssh-lock');
    if (opener) opener.setAttribute('aria-expanded', 'true');
    var first = drawer.querySelector('.ssh-drawer__panel button, .ssh-drawer__panel a');
    if (first) first.focus();
  }
  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.hidden = true;
    document.documentElement.classList.remove('ssh-lock');
    if (opener) { opener.setAttribute('aria-expanded', 'false'); opener.focus(); }
  }
  if (opener) opener.addEventListener('click', openDrawer);
  if (drawer) {
    drawer.addEventListener('click', function (e) { if (e.target.closest('[data-ssh-close]')) closeDrawer(); });
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeDrawer(); return; }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.slice.call(drawer.querySelectorAll('.ssh-drawer__panel a, .ssh-drawer__panel button'));
      if (!f.length) return;
      var a = f[0], z = f[f.length - 1];
      if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
    });
  }

  /* ---------- compact nav: switch to the menu button before the category row would wrap or clip ---------- */
  var hd = document.querySelector('[data-ssh-header]');
  var navIn = hd && hd.querySelector('.ssh-nav__in');
  function fitNav() {
    if (!hd || !navIn) return;
    hd.classList.remove('ssh-hd--compact');
    var nav = hd.querySelector('.ssh-nav');
    if (!nav || getComputedStyle(nav).display === 'none') return;
    var list = navIn.querySelector('.ssh-nav__list');
    var trade = navIn.querySelector('.ssh-nav__trade');
    var need = list.scrollWidth + (trade ? trade.offsetWidth + 24 : 0);
    var cs = getComputedStyle(navIn);
    var room = navIn.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    if (need > room || list.scrollWidth > list.clientWidth + 1) hd.classList.add('ssh-hd--compact');
  }
  if (hd) {
    fitNav();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitNav);
    var rt;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(fitNav, 120); });
  }

  /* keep the basket count current after AJAX adds elsewhere on the site */
  document.addEventListener('cart:update', function () { refreshCount(); });
  function refreshCount() {
    var n = document.querySelector('[data-ssh-cart-count]');
    if (!n) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { n.textContent = c.item_count; }).catch(function () {});
  }

  /* ---------- bund size calculator (formula unchanged) ---------- */
  var calc = document.querySelector('[data-ssh-calc]');
  if (calc) {
    var units = [];
    try { units = JSON.parse(calc.querySelector('[data-ssh-units]').textContent); } catch (err) { units = []; }
    var nIn = calc.querySelector('[data-ssh-n]');
    var reqEl = calc.querySelector('[data-ssh-req]');
    var list = calc.querySelector('[data-ssh-list]');
    var none = calc.querySelector('[data-ssh-none]');
    var names = { can: ['can', 'cans'], drum: ['drum', 'drums'], ibc: ['IBC', 'IBCs'] };
    var esc = function (s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); };
    var fmt = function (l) { var r = Math.round(l * 10) / 10; return r.toLocaleString('en-GB', { maximumFractionDigits: 1 }) + ' L'; };
    var count = function () { var n = parseInt(nIn.value, 10); if (isNaN(n) || n < 1) n = 1; if (n > 99) n = 99; return n; };
    var update = function () {
      var t = calc.querySelector('input[name="ssh-type"]:checked');
      var kind = t ? t.value : 'drum';
      var each = t ? parseFloat(t.getAttribute('data-l')) : 205;
      var n = count();
      var req = Math.max(each * 1.1, each * n * 0.25);
      reqEl.textContent = fmt(req);
      var fits = units.filter(function (u) { return u.k === kind && u.h >= n && u.s >= req; })
        .sort(function (a, b) { return a.pc - b.pc; }).slice(0, 3);
      list.innerHTML = fits.map(function (u) {
        var holds = 'Holds ' + u.h + ' ' + (u.h === 1 ? names[kind][0] : names[kind][1]);
        return '<li class="ssh-calc__item"><div class="ssh-calc__info"><a class="ssh-calc__t" href="' + esc(u.u) + '">' + esc(u.t) + '</a>' +
          '<span class="ssh-calc__s"><span>' + u.s.toLocaleString('en-GB') + ' L sump</span><span>' + holds + '</span></span></div>' +
          '<div class="ssh-calc__buy"><span class="ssh-calc__p">' + esc(u.p) + '<small>inc. VAT</small></span>' +
          '<a class="ssh-calc__view" href="' + esc(u.u) + '" tabindex="-1" aria-hidden="true">View product →</a></div></li>';
      }).join('');
      if (fits.length) { none.hidden = true; none.innerHTML = ''; }
      else {
        none.innerHTML = 'No single unit in our range holds ' + n + ' ' + (n === 1 ? names[kind][0] : names[kind][1]) + ' with a ' + fmt(req) + ' sump. <a href="/pages/contact">Ask us</a> about splitting the load across units or a bunded store.';
        none.hidden = false;
      }
    };
    calc.addEventListener('change', function (e) { if (e.target.name === 'ssh-type' || e.target === nIn) { nIn.value = count(); update(); } });
    nIn.addEventListener('input', function () { if (nIn.value !== '') update(); });
    calc.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ssh-step]');
      if (!b) return;
      nIn.value = Math.min(99, Math.max(1, count() + parseInt(b.getAttribute('data-ssh-step'), 10)));
      update();
    });
    update();

    /* expandable panel: starts closed so category browsing comes first; selections are kept while it is closed */
    var tog = calc.querySelector('[data-ssh-calc-toggle]');
    var body = calc.querySelector('#ssh-calc-body');
    var setOpen = function (open) { tog.setAttribute('aria-expanded', open ? 'true' : 'false'); body.hidden = !open; };
    if (tog && body) {
      setOpen(false);
      tog.addEventListener('click', function () { setOpen(tog.getAttribute('aria-expanded') !== 'true'); });
    }
  }

  /* ---------- guide dialogs (native modal: focus inside, Esc closes, focus returns) ---------- */
  function openGuide(id, trigger) {
    var d = document.getElementById(id);
    if (!d) return;
    d._opener = trigger;
    if (d.showModal) { if (!d.open) d.showModal(); } else d.setAttribute('open', '');
    document.documentElement.classList.add('ssh-lock-dlg');
    d.scrollTop = 0;
    var x = d.querySelector('[data-ssh-guide-close]'); if (x) x.focus();
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-ssh-guide-open]');
    if (o) { e.preventDefault(); openGuide(o.getAttribute('data-ssh-guide-open'), o); return; }
    var c = e.target.closest('[data-ssh-guide-close]');
    if (c) { var dl = c.closest('dialog'); if (dl) { if (dl.close) dl.close(); else dl.removeAttribute('open'); } return; }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('ssh-dlg')) {
      var r = e.target.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) e.target.close();
    }
  });
  Array.prototype.forEach.call(document.querySelectorAll('.ssh-dlg'), function (d) {
    d.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = Array.prototype.slice.call(d.querySelectorAll('a[href], button:not([disabled])'));
      if (!f.length) return;
      var a = f[0], z = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === a || !d.contains(document.activeElement))) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && (document.activeElement === z || !d.contains(document.activeElement))) { e.preventDefault(); a.focus(); }
    });
    d.addEventListener('close', function () {
      document.documentElement.classList.remove('ssh-lock-dlg');
      if (d._opener && document.contains(d._opener)) d._opener.focus();
    });
  });

  /* ---------- workplace carousel controls (mobile) ---------- */
  Array.prototype.forEach.call(document.querySelectorAll('[data-ssh-work]'), function (sec) {
    var track = sec.querySelector('[data-ssh-work-track]');
    var prev = sec.querySelector('[data-ssh-work-prev]');
    var next = sec.querySelector('[data-ssh-work-next]');
    var pos = sec.querySelector('[data-ssh-work-pos]');
    if (!track || !prev || !next) return;
    var cards = Array.prototype.slice.call(track.children);
    var idx = function () {
      var left = track.scrollLeft, best = 0, bd = Infinity;
      cards.forEach(function (c, i) { var d = Math.abs(c.offsetLeft - track.offsetLeft - left); if (d < bd) { bd = d; best = i; } });
      return best;
    };
    var draw = function () {
      var i = idx();
      var end = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      prev.disabled = track.scrollLeft < 4;
      next.disabled = end;
      if (pos) pos.textContent = (end ? cards.length : i + 1) + ' of ' + cards.length;
    };
    var go = function (d) {
      var i = Math.max(0, Math.min(cards.length - 1, idx() + d));
      track.scrollTo({ left: cards[i].offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    };
    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    var st;
    track.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(draw, 60); }, { passive: true });
    track.addEventListener('focusin', function (e) {
      var li = e.target.closest('li');
      if (li && li.scrollIntoView) li.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reduce ? 'auto' : 'smooth' });
    });
    draw();
  });
})();
